import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getGate } from '../../services/gateService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import GateAccessPointsTab from './tab-pages/GateAccessPointsTab';
import GateScopeTab from './tab-pages/GateScopeTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function GateDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [gate, setGate] = useState(null);
  const [activeTab, setActiveTab] = useState('accessPoints');

  useEffect(() => {
    getGate(id)
      .then((res) => setGate(res.data?.data))
      .catch(() => {});
  }, [id]);

  const tabs = [
    { key: 'accessPoints', label: t('accessPoint.title') },
    { key: 'scope', label: t('gate.scopeTab') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('gate.title'), path: '/gates' },
          { label: gate?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'accessPoints' && <GateAccessPointsTab gateId={id} />}
        {activeTab === 'scope' && <GateScopeTab gateId={id} />}
      </TabContent>
    </PageContainer>
  );
}
